//TODO FORSE DA RINOMINARE IN FRANCESE (SOLO LA STRINGA EH)
export enum RoutePath {
  Root = '/',
  Registration = '/registration',
  PersonalData = 'personal-data',
  SignupPDV = '/pdv-account-activation',
  SecurityData = 'security-data',
  SignumConfirmationEmail = '/email-confirmation',
  Oops = '/oops',
}
